import { http } from "./http";
import { GET_ISR_AGENCY_LIST_URL, GET_ISR_USER_DETAILS_URL, GET_ISR_USER_EMAIL_LIST_URL } from "./URL";

export const getIsrAgencyList = async (payload: Record<string, unknown> = {}) => {
  const response = await http.post(GET_ISR_AGENCY_LIST_URL, payload);
  return response;
};

export const getIsrUserEmailList = async (payload: { email?: string } = {}) => {
  const response = await http.post(GET_ISR_USER_EMAIL_LIST_URL, payload);
  return response;
};

export const getIsrUserDetails = async (payload: { userId?: number; email?: string }) => {
  const response = await http.post(GET_ISR_USER_DETAILS_URL, payload);
  return response;
};
